<ng-template #oeblock let-oe>
  <strong class="app-cursor-pointer" style="white-space: normal;" (click)="more()">
    {{oe.oeEName}} {{oe.oeName}}
    <i class="fa-regular fa-circle-info"></i>
  </strong>
  <div class="typo-small" style="line-height: initial">
    <div class="grid">
      <ng-container *ngIf="showAddress == 1 && getAddress(oe,2) as address">
        <div>{{address.adrStr}} {{address.adrHNum}} </div>
        <div>{{address.adrPlz}} {{address.adrOrt}}</div>
      </ng-container>
    </div>
    <div class="grid-auto-1" *ngIf="showContacts">
      <ng-container *ngIf="getKontakt(oe,1) as kontakt">
        <div>{{enumSvc.getEnumerationText("KontaktTyp", kontakt.kont_enmIdent_KontaktTyp)}}:&nbsp;</div>
        <div>{{kontakt.kontVal}}</div>
      </ng-container>
      <ng-container *ngIf="showAllContacts == 1 && getKontakt(oe,5) as kontakt">
        <div>{{enumSvc.getEnumerationText("KontaktTyp", kontakt.kont_enmIdent_KontaktTyp)}}:&nbsp;</div>
        <div>{{kontakt.kontVal}}</div>
      </ng-container>
      <ng-container *ngIf="getKontakt(oe,28) as kontakt">
        <div>{{enumSvc.getEnumerationText("KontaktTyp", kontakt.kont_enmIdent_KontaktTyp)}}:&nbsp;</div>
        <div>{{kontakt.kontVal}}</div>
      </ng-container>
      <ng-container *ngIf="showAllContacts == 1 && getKontakt(oe,3) as kontakt">
        <div>{{enumSvc.getEnumerationText("KontaktTyp", kontakt.kont_enmIdent_KontaktTyp)}}:&nbsp;</div>
        <div>{{kontakt.kontVal}}</div>
      </ng-container>
      <div><a href="javascript:void(0)" style="color: var(--c-dark);text-decoration: none; display:inline" (click)="more()">(mehr...)</a></div>
    </div>
  </div>
</ng-template>

<div *ngIf="data as OE">
  <ng-container *ngTemplateOutlet="oeblock; context: {$implicit: OE}"></ng-container>
</div>
